













































import { PersonalInfo, LevelProgress, ProfileTiles, SeasonSelect, SkillProgress } from '@/components';
import { geekProfileMixin } from '@/shared';
import { Season } from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(geekProfileMixin).extend({
  name: 'BasicGeekProfileView',
    components: {
    PersonalInfo,
    LevelProgress,
    ProfileTiles,
    SeasonSelect,
    SkillProgress,
  },
  created() {
    this.initializeProfile();
  },
  methods: {
    async initializeProfile() {
      this.loader.isProfilePending = true;
      try {
        await this.$store.dispatch(Actions.seasons.fetchAllSeasons),
        await this.$store.dispatch(Actions.seasons.fetchCurrentSeason);
        this.activeSeason = this.$route.query.seasonId
          ? this.seasons.find((s: Season) => s.id === this.$route.query.seasonId) as Season
          : this.currentSeason as Season;
        await Promise.all([
          this.$store.dispatch(Actions.geek.fetchGeekBasicInfo, this.profileId),
          this.$store.dispatch(
            Actions.scores.fetchGeekGeneralScore,
            { seasonId: this.activeSeason.id, geekId: this.profileId },
          ),
          this.$store.dispatch(Actions.opportunities.fetchGeekOpportunitiesCount, this.profileId),
        ]);
      } finally {
        this.loader.isProfilePending = false;
      }
    },
  },
});
